<template>
<svg viewBox="0 0 48 49" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-office-building-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.536 3.787l39.598 39.598a1 1 0 010 1.414l-1.415 1.414a1 1 0 01-1.414 0L2.707 6.615a1 1 0 010-1.414l1.414-1.414a1 1 0 011.415 0zM6 14.15l4 4v23.93h6v-7a1 1 0 011-1h6a1 1 0 011 1v7h6v-3.93l7.929 7.93H8.154c-1.19 0-2.154-.985-2.154-2.2V14.15zM31.846 2.08c1.19 0 2.154.985 2.154 2.2v5.8h6a2 2 0 012 2v23.929l-4-4v-17.93h-4v13.93l-4-4V6.079H12.071L8.074 2.082h.04l23.732-.001zM14 22.15l3.93 3.93H14v-3.93zm12-8.07v4h-1.929L22 16.009v-1.93h4z"/></svg>
</template>
<script>

export default {
  name: 'IconOfficeBuildingOff',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
